import React from 'react';

interface IFrameProps {
    key: number;
    src: string;
    id: string;
}

const MyIframe: React.FC<IFrameProps> = (p: { src: string, id: string, key: number }) => {
    return (
        <iframe src={p.src} id={p.id} key={p.key + Math.random()}/>
    );
};

export default MyIframe;